import {
  STRIPE_GET_CONTACT_INFO,
  STRIPE_GET_CONTACT_INFO_SUCCESS,
  STRIPE_GET_CONTACT_INFO_ERROR,
  STRIPE_CLEAR_DATA,
} from '../actions';

//* GET CONTACT INFO from Stripe // ---------------------------------------------------------------------------------------------
export const getContactInfoStripe = (payload) => {
  //console.log(payload);

  return {
    type: STRIPE_GET_CONTACT_INFO,
    payload: payload,
  };
};

export const getContactInfoStripeSuccess = (items) => {
  // console.log(items);
  return { type: STRIPE_GET_CONTACT_INFO_SUCCESS, payload: items };
};

export const getContactInfoStripeError = (error) => ({
  type: STRIPE_GET_CONTACT_INFO_ERROR,
  payload: error,
});

//* CLEAR DATA in Redux// ---------------------------------------------------------------------------------------------
// clearing redux state at logout
export const clearDataStripe = (history) => {
  return {
    type: STRIPE_CLEAR_DATA,
    payload: { history },
  };
};
